var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Autocomplete',{attrs:{"placeholder":_vm.$t('placeholder.sport_type_or_club'),"items":_vm.items,"input-value":_vm.search,"is-clearable":true,"handler-function":_vm.querySelections},on:{"emitSelection":_vm.saveSelection}})
}
var staticRenderFns = []

export { render, staticRenderFns }